import React from 'react'
import { EStatus } from '@unfoldrtech/portal-mic'
import I18NText from '../../I18NText'

const statusTextMap: Record<EStatus, string> = {
  [EStatus.Active]: 'active',
  [EStatus.Inactive]: 'inactive',
  [EStatus.Disabled]: 'disabled',
}

export function CurrentStatusText({
  status,
  lowercase,
}: {
  status?: EStatus
  lowercase: boolean
}) {
  if (!status) {
    return <></>
  }

  const statusTranslationId = statusTextMap[status]
  return <I18NText lowercase={lowercase} id={statusTranslationId} />
}
